export default __webpack_public_path__ + "static/media/hello-light.65c25f43.webp";